import React from "react";
import styles from "./surveysNoResults.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/pro-solid-svg-icons";
import NoResultsWithButton from "components/noResultsWithButton/NoResultsWithButton";

export interface SurveysNoResultsProps {
  description?: string;
  title?: string;
  createSurveyButton?: React.ReactElement;
  filtered?: boolean;
}

const SurveysNoResults: React.FC<SurveysNoResultsProps> = ({
  createSurveyButton,
  filtered,
  description = "Looks like you don't have any survey assets yet.",
  title = "You don't have any survey assets",
}) => {
  return (
    <NoResultsWithButton
      title={title}
      description={description}
      icon={<FontAwesomeIcon icon={faList} className={styles.surveysNoResultsIcon} />}
      actionButton={createSurveyButton}
      filtered={filtered}
    />
  );
};

export default SurveysNoResults;
